import React from 'react';
import { useArchitectureStore } from '../../store/useArchitectureStore';
import { useArchitectureGenerator } from '../../hooks/useArchitectureGenerator';
import { Sparkles, Loader2 } from 'lucide-react';

import TimeOfDaySelector from './TimeOfDaySelector';

const ArchitectureBottomBar: React.FC = () => {
    const { sourceImage, isProcessing, activeTask } = useArchitectureStore();
    const { generate } = useArchitectureGenerator();

    const handleGenerate = () => {
        if ((sourceImage || activeTask) && !isProcessing) {
            generate();
        }
    };

    return (
        <div className="absolute bottom-4 left-4 right-4 md:left-auto md:bottom-6 md:right-6 z-30 flex flex-col md:flex-row items-end md:items-center justify-end gap-3 pointer-events-none">            {/* Time of Day Selector */}
            <div className="w-full md:w-auto flex justify-end">
                <TimeOfDaySelector />
            </div>

            {/* Prominent Generate Button */}
            <button
                onClick={handleGenerate}
                disabled={!sourceImage || isProcessing}
                className={`
                    w-full md:w-auto pointer-events-auto group relative flex items-center justify-center gap-3 px-8 py-3 md:py-4 rounded-xl md:rounded-full shadow-2xl transition-all duration-300 transform
                    ${!sourceImage
                        ? 'bg-stone-800 text-stone-600 cursor-not-allowed border border-stone-700'
                        : isProcessing
                            ? 'bg-stone-800 text-stone-400 cursor-wait border border-stone-700'
                            : 'bg-gradient-to-r from-amber-500 to-orange-600 text-white shadow-orange-900/50 hover:scale-105 active:scale-95 border border-orange-400/30'
                    }
                `}
            >
                {/* Glow Effect */}
                {!isProcessing && sourceImage && (
                    <div className="absolute inset-0 rounded-full ring-2 ring-white/20 group-hover:ring-white/40 transition-all opacity-0 group-hover:opacity-100" />
                )}

                {isProcessing ? (
                    <>
                        <Loader2 size={20} className="animate-spin" />
                        <span className="font-bold tracking-widest text-sm">GENERATING...</span>
                    </>
                ) : (
                    <>
                        <Sparkles size={20} className={sourceImage ? 'animate-pulse' : ''} />
                        <span className="font-bold tracking-widest text-sm">GENERATE</span>
                    </>
                )}
            </button>
        </div>
    );
};

export default ArchitectureBottomBar;
